import update from 'immutability-helper';
import ActionTypes from '../constants/action-types';
import { ExperienceState } from '../types';
import { RootActionTypes } from '../../../stores/types';

type State = ExperienceState['entities']['deliveredDutyOptions'];

const initialState: State = {
  options: [],
};

export default function (state: State = initialState, action: RootActionTypes): State {
  switch (action.type) {
    case ActionTypes.FETCH_DELIVERED_DUTY_OPTIONS_SUCCESS:
      return update(state, { $set: action.payload });
    default:
      return state;
  }
}
